module.exports = __webpack_public_path__ + "static/img/1_1.8dc1979.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new/1_1.png
// module id = 5pqn
// module chunks = 0